import { TweenMax, easeOut } from 'gsap/all';


function Player(file) {
    let audio = document.querySelectorAll('.audio-media'),
        playBtn = document.querySelector('.playpause');
    let totalTime = document.querySelector('.total-time'),
        currentTime = document.querySelector('.current-time'),
        progressWrap = document.querySelector('.progress-bar'),
        progressBar = document.querySelector('.progress');


    //totalTime.textContent = audio.duration;
    var time = document.getElementById('traccia01');
    function readableDuration(duration){
        var sec = Math.floor( duration );
        var min = Math.floor( sec / 60 );
        min = min >= 10 ? min : '0' + min;
        sec = Math.floor( sec % 60 );
        sec = sec >= 10 ? sec : '0' + sec;
        return min + '.' + sec;
    }

    if(totalTime) {
        totalTime.textContent = readableDuration(time.duration);
    }

    function setTime(media) {
        var minutes = Math.floor(media.currentTime / 60);
        var seconds = Math.floor(media.currentTime - minutes * 60);
        var minuteValue;
        var secondValue;

        if( minutes < 10 ) {
            minuteValue = '0' + minutes;
        } else {
            minuteValue = minutes;
        }

        if( seconds < 10 ) {
            secondValue = '0' + seconds;
        } else {
            secondValue = seconds;
        }

        var mediaTime = minuteValue + '.' + secondValue;
        currentTime.textContent = mediaTime;

        var progress = progressWrap.clientWidth * (media.currentTime / media.duration );
        TweenMax.to(progressBar, 1, { width: progress + 'px' });

    }


    if(playBtn) {
        playBtn.addEventListener('click', (event) => {
            let _this = event.target || window.event;
            let track = _this.getAttribute('data-track');
            let trackToPlay = document.getElementById(track);
            if(_this.classList.contains('playing')) {
                trackToPlay.pause();
                TweenMax.set([trackToPlay, _this], { className: '-=playing'})
            } else {
                trackToPlay.play();
                TweenMax.set([trackToPlay, _this], { className: '+=playing'})
            }

            trackToPlay.addEventListener('timeupdate', function() {
                setTime(trackToPlay)
            });

        })
    }




}


export default Player;



// WEBPACK FOOTER //
// ./resources/js/components/Player.js